import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OauthQuestionnaireComponent } from './oauth-questionnaire.component';
import { OauthConnectModule } from 'src/app/components/oauth-connect/oauth-connect.module';
import {TranslateModule} from '@xref/ngx';

@NgModule({
    declarations: [OauthQuestionnaireComponent],
    imports: [
        CommonModule,
        OauthConnectModule,
        TranslateModule
    ]
})
export class OauthQuestionnaireModule { }
